// extracted by mini-css-extract-plugin
export default {"loginSideImage":"Auth_loginSideImage__NttjO","active":"Auth_active__PQ+mC"};